import { ROUTES } from '../config/router/routes';

export const EMAIL_VERIFY_SETTINGS_TAB = ROUTES.settings.page + '#email-verify';
